import { useEffect, useRef } from 'react';
import { showToast } from '../utils/swalHandler';

/**
 * Warns the user once per upload session when the tab goes to the background,
 * because mobile browsers may pause or throttle in-flight uploads.
 *
 * @param {boolean} isUploading
 */
export const useUploadBackgroundGuard = (isUploading) => {
  const hasWarnedRef = useRef(false);

  useEffect(() => {
    if (!isUploading) {
      hasWarnedRef.current = false;
      return undefined;
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'hidden' || hasWarnedRef.current) {
        return;
      }

      hasWarnedRef.current = true;
      showToast(
        'Keep this screen open while uploading. Switching apps may pause the upload.',
        'warning',
        { timer: 6000 }
      );
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isUploading]);
};
